export const MONTHS_STATUSES = {
  OPEN: 'open',
  CLOSE: 'close',
  PROGRESS: 'progress',
};
